import React from "reactn"
import { Flex, Spinner } from "@chakra-ui/core"
export const Loading = () => (
  <Flex align="center" justify="center" borderWidth="0px" h="100%">
    <Spinner thickness="4px" speed="0.3s" color="red.200" size="xl" />
  </Flex>
)
